import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Chip from '@mui/material/Chip';
import Tooltip from '@mui/material/Tooltip';

const MemberJoinStatus = ({ member, ...rest }) => {
  const { t } = useTranslation(['chat', 'common']);

  if (!member?.notJoined) {
    return null;
  }

  const isInvited = member.notJoinedReason === 'INVITED';
  const label = isInvited ? t('common:status.invited') : t('chat:memberStatus.notJoined');
  const tooltip = isInvited ? t('chat:memberStatus.invitedTooltip') : t('chat:memberStatus.notJoinedTooltip');

  return (
    <Tooltip title={tooltip}>
      <Chip
        size="small"
        label={label}
        sx={{ height: 18, fontSize: '0.7rem', '& .MuiChip-label': { px: 0.75 } }}
        {...rest}
      />
    </Tooltip>
  );
};

MemberJoinStatus.propTypes = {
  member: PropTypes.shape({
    notJoined: PropTypes.bool,
    notJoinedReason: PropTypes.string,
  }),
};

export const renderMemberJoinStatus = (member) => <MemberJoinStatus member={member} />;

export const isNotJoined = (member) => !!member?.notJoined;

export default MemberJoinStatus;
